import { render, staticRenderFns } from "./InputUpload.vue?vue&type=template&id=0a2b7e86&scoped=true&"
import script from "./InputUpload.vue?vue&type=script&lang=js&"
export * from "./InputUpload.vue?vue&type=script&lang=js&"
import style0 from "./InputUpload.vue?vue&type=style&index=0&id=0a2b7e86&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0a2b7e86",
  null
  
)

export default component.exports